import { Discount } from '../../../../../../types/api/discounts/Discount';

export const getDiscountAmount = (discount: Discount, total: number) => {
    if (discount.method === 'fixed') {
        return discount.amount;
    }

    const percentage = discount.amount / 100;
    return Math.floor(total * percentage);
}
